export function atlasTypographyLengthToPx(value: number): string {
  return `${value}px`;
}
